/**
 * Node Modules
 */
import React from 'react'

/**
 * Application Modules
 */
import './style.css'

/**
 * Component
 */
export default function Section({ id, className, children, styles }) {
  return (
    <section style={styles} id={id} className={`clearfix ${className}`}>
      {children}
    </section>
  )
}
